import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		filterBar: {
			marginBottom: theme.spacing(2),
		},
		detailLabel: {
			fontWeight: 600,
		},
		message: {
			whiteSpace: "pre-line",
		},
		actions: {
			display: "flex",
			flexWrap: "wrap",
			gap: theme.spacing(1),
		},
	} satisfies Record<string, CSSObject>);
};
